import { Card, Row, Col, Container, Image,ListGroup,Button } from "react-bootstrap";
import courseImg from "../../../assets/course_img/default_course_cover.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClockFour, faVideo,faQuestionCircle , faBook , faGears, faArrowLeft, faBookOpen} from "@fortawesome/free-solid-svg-icons";
export default function CoursViewer(props) {    
    if(props.course){
        const countLessons = props.course.lessons.length;
        let countVideos = 0;
        let counstTextMaterials = 0;
        let countTrainingTasks = 0;
        let countPactice = 0;
         props.course.lessons.map((lesson)=>{
            lesson.countVideos = 0;
            lesson.countQuesionts = 0;
            lesson.countDocuments = 0;
            lesson.countPractice = 0;
            lesson.topics.map((topic)=>{
                topic.countVideos = 0;
                topic.countQuestions =0;
                topic.countDocuments = 0;
                topic.countPractice = 0;
                topic.steps.map((step)=>{
                    
                    switch(step.name){
                        case 'video':
                            topic.countVideos++;
                            countVideos++;
                            lesson.countVideos++;
                            break;
                        case 'question':
                            countTrainingTasks++;
                            lesson.countQuesionts++;
                            topic.countQuestions++;
                            break;
                        case 'document':
                            lesson.countDocuments++;
                            counstTextMaterials++;
                            topic.countDocuments++;
                            break;
                        case 'vr':
                            lesson.countPractice++;
                            countPactice++;
                            topic.countPractice++;
                            break;
                    }
                })
            })
        })
        return (
            <Container style={{overflow:"auto"}}>
                <Row>
                    <Col xs={12} sm={12} lg={12} md={12} xl={12}>
                        <Card className="mt-5">
                            <Card.Header>
                                <Card.Title>Общая информация о курсе</Card.Title>
                            </Card.Header>
                            <Card.Body>
                                <Row>
                                    <Col xs={2} sm={2} md={2} lg={2}  xl={2}>
                                        <Image className="w-100" src={props.course.file??courseImg} rounded />
                                    </Col>    
                                    <Col>
                                        <Row>
                                            <Col xs={12} sm={12} lg={12} md={12} xl={12}>
                                                <h2>{props.course.title}</h2>
                                                <hr/>
                                            </Col>    
                                            <Col>
                                                {
                                                    props.course.description ? 
                                                        <p style={{fontSize:"2em", margin:0}}>{props.course.description}</p> 
                                                    : 
                                                        <p style={{fontSize:"2em", margin:0}} className='text-muted'>{props.t("This course has no description.")}</p>
                                                }
                                            </Col>                                  
                                            <Col  xs={12} sm={12} lg={12} md={12} xl={12}>
                                                <Row>                                                   
                                                        <Col  xs={12} sm={12}  md={6} lg={4}  xl={4}>
                                                            <p style={{fontSize:"2em", margin:0}}>{props.t("Number of video content")}:{countVideos}</p>
                                                        </Col>
                                                        <Col  xs={12} sm={12}  md={6} lg={4}  xl={4}>
                                                            <p style={{fontSize:"2em", margin:0}}>{props.t("Number of text materials")}:{counstTextMaterials}</p>
                                                        </Col>
                                                        <Col  xs={12} sm={12}  md={6} lg={4}  xl={4}>
                                                            <p style={{fontSize:"2em", margin:0}}>{props.t("Estimated transit time")}:{props.course.passage_time} {props.t('minutes')}</p>
                                                        </Col>
                                                        <Col  xs={12} sm={12}  md={6} lg={4}  xl={4}>
                                                            <p style={{fontSize:"2em", margin:0}}>{props.t("Number of training tasks")}:{countTrainingTasks}</p>
                                                        </Col>
                                                        <Col  xs={12} sm={12}  md={6} lg={4}  xl={4}>
                                                            <p style={{fontSize:"2em", margin:0}}>{props.t("Number of practical tasks")}:{countPactice}</p>
                                                        </Col>
                                                </Row>                                                    
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>                            
                            </Card.Body>                
                        </Card>
                    </Col>
                    <Col>
                        <Row>
                            {Array.prototype.map.call(props.course.lessons, function(lesson,index){
                                return <Col className="mt-5" key={index} xs={12} sm={12}  md={6} lg={4}  xl={4}>
                                        <Card>
                                            <Card.Header>
                                                <Card.Title>{lesson.title}</Card.Title>
                                            </Card.Header>
                                            <Card.Body>      
                                                 <Card.Text>
                                                    {lesson.description?? props.t("The lesson description is missing")}
                                                 </Card.Text>
                                                 <Row>
                                                    <Col>
                                                        {props.t('Count questions')}: {lesson.countQuesionts ?? 0}
                                                    </Col>
                                                    <Col>
                                                        {props.t('Count Videos')}: {lesson.countVideos ?? 0}
                                                    </Col>
                                                    <Col>
                                                        {props.t('Count documents')}: {lesson.countDocuments ?? 0}
                                                    </Col>
                                                    <Col>
                                                        {props.t('Passage time')}: {lesson.passage_time} {props.t('minutes')}
                                                    </Col>
                                                    <Col>
                                                        {props.t('Number of practical tasks')}: {lesson.countPractice}
                                                    </Col>
                                                 </Row>                                                  
                                            </Card.Body>
                                            <Card.Footer>
                                                <Button style={{borderRadius:"0",backgroundColor:"#1E874A", borderColor:"#1E874A"}} onClick={()=>{props.handleChangeContent('viewLesson', index)}} variant="info" title={props.t("View details")}>
                                                    <FontAwesomeIcon icon={faBookOpen} className={'mr-1'}></FontAwesomeIcon>
                                                    {props.t("View details")}</Button>
                                            </Card.Footer>
                                        </Card>
                                 </Col>
                            })}
                        </Row>
                    </Col>
                </Row>
            </Container>
        );
    }else{
        return(<></>);
    }
}